import { render } from "./AddFicherosPaciente.vue?vue&type=template&id=0862ea2a"
import script from "./AddFicherosPaciente.vue?vue&type=script&lang=js"
export * from "./AddFicherosPaciente.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__